import { useContext } from 'react';
import { PolicyRenewalJobContext } from './context';

export default function usePolicyRenewalJobContext() {
  return useContext(PolicyRenewalJobContext);
}
